import React, { useMemo } from 'react';
import { formatCortadMonth } from 'utils/cortadLayers';
import './CortadTimeline.css';

const CortadTimeline = ({
  months = [],
  month = '',
  onMonthChange,
  variableLabel = 'Thermal stress',
}) => {
  const index = Math.max(0, months.indexOf(month));
  const ticks = useMemo(() => {
    if (!months.length) return [];
    const first = months[0].slice(0, 4);
    const last = months[months.length - 1].slice(0, 4);
    return [first, last];
  }, [months]);

  if (!months.length) {
    return (
      <div className="cortad-timeline">
        <div className="cortad-timeline-label">CoRTAD timeline is not available.</div>
      </div>
    );
  }

  return (
    <div className="cortad-timeline">
      <div className="cortad-timeline-head">
        <span>{variableLabel}</span>
        <strong>{formatCortadMonth(month || months[index])}</strong>
      </div>
      <input
        type="range"
        min={0}
        max={months.length - 1}
        step={1}
        value={index}
        onChange={(event) => onMonthChange?.(months[Number(event.target.value)])}
        className="cortad-timeline-slider"
        aria-label="CoRTAD date"
      />
      <div className="cortad-timeline-ticks">
        <span>{ticks[0]}</span>
        <span>{ticks[1]}</span>
      </div>
    </div>
  );
};

export default CortadTimeline;
